import script from "./UploadCom.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadCom.vue?vue&type=script&setup=true&lang=js"

import "./UploadCom.vue?vue&type=style&index=0&id=5ad4090a&lang=less&scoped=true"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ad4090a"]])

export default __exports__